import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

export default function ExclamationCircle({ width = 18, height = 18, fill = 'white' }: IconProps) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.0013 0.666992C4.4013 0.666992 0.667969 4.40033 0.667969 9.00033C0.667969 13.6003 4.4013 17.3337 9.0013 17.3337C13.6013 17.3337 17.3346 13.6003 17.3346 9.00033C17.3346 4.40033 13.6013 0.666992 9.0013 0.666992ZM9.0013 9.83366C8.54297 9.83366 8.16797 9.45866 8.16797 9.00033V5.66699C8.16797 5.20866 8.54297 4.83366 9.0013 4.83366C9.45964 4.83366 9.83464 5.20866 9.83464 5.66699V9.00033C9.83464 9.45866 9.45964 9.83366 9.0013 9.83366ZM9.83464 13.167H8.16797V11.5003H9.83464V13.167Z"
        fill={fill}
      />
    </Svg>
  );
}
